import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "documente-wrapper" }
const _hoisted_2 = { class: "circle-container" }
const _hoisted_3 = {
  key: 0,
  class: "circle circle-true"
}
const _hoisted_4 = {
  key: 1,
  class: "circle circle-false"
}
const _hoisted_5 = { class: "url-textbox" }
const _hoisted_6 = { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }
const _hoisted_7 = { style: {"display":"flex","flex-direction":"column","height":"100%"} }
const _hoisted_8 = { style: {"flex":"1","border-top":"1px solid #ddd"} }
const _hoisted_9 = ["src"]
const _hoisted_10 = { style: {"display":"flex","justify-content":"center","align-items":"center","gap":"16px","padding":"12px"} }
const _hoisted_11 = { class: "tip-popup-content" }
const _hoisted_12 = { class: "form-footer footer-modern" }
const _hoisted_13 = { class: "footer-right" }
const _hoisted_14 = { class: "popup-header" }
const _hoisted_15 = { class: "popup-header-title" }
const _hoisted_16 = { class: "tab-title-wrapper" }
const _hoisted_17 = { class: "tab-title-text" }
const _hoisted_18 = { class: "accordion-item-content" }
const _hoisted_19 = {
  key: 0,
  class: "filter-group-inner"
}
const _hoisted_20 = { class: "filter-input" }
const _hoisted_21 = {
  key: 0,
  class: "filter-input"
}
const _hoisted_22 = {
  key: 1,
  class: "filter-input"
}
const _hoisted_23 = { class: "filter-input" }
const _hoisted_24 = { class: "filter-input" }
const _hoisted_25 = {
  key: 2,
  class: "filter-input"
}
const _hoisted_26 = {
  key: 1,
  class: "filter-group-inner"
}
const _hoisted_27 = {
  key: 0,
  class: "tab-empty-state"
}
const _hoisted_28 = {
  key: 1,
  class: "filter-input"
}
const _hoisted_29 = {
  key: 2,
  class: "filter-input"
}
const _hoisted_30 = {
  key: 3,
  class: "filter-input"
}
const _hoisted_31 = { class: "form-field-grid" }
const _hoisted_32 = {
  key: 2,
  class: "filter-group-inner"
}
const _hoisted_33 = {
  key: 0,
  class: "tab-empty-state"
}
const _hoisted_34 = {
  key: 1,
  class: "filter-input"
}
const _hoisted_35 = {
  key: 2,
  class: "filter-input"
}
const _hoisted_36 = {
  key: 3,
  class: "filter-input"
}
const _hoisted_37 = {
  key: 4,
  class: "filter-input"
}
const _hoisted_38 = {
  key: 5,
  class: "filter-input"
}
const _hoisted_39 = {
  key: 6,
  class: "filter-input"
}
const _hoisted_40 = {
  key: 3,
  class: "filter-group-inner"
}
const _hoisted_41 = { class: "filter-input" }
const _hoisted_42 = { class: "checkbox-grid" }
const _hoisted_43 = {
  key: 4,
  class: "filter-group-inner"
}
const _hoisted_44 = {
  key: 0,
  class: "tab-empty-state"
}
const _hoisted_45 = {
  key: 1,
  class: "filter-input"
}
const _hoisted_46 = {
  key: 2,
  class: "filter-input"
}
const _hoisted_47 = { class: "form-footer footer-modern" }
const _hoisted_48 = { class: "footer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxTexts = _resolveComponent("DxTexts")!
  const _component_DxGrouping = _resolveComponent("DxGrouping")!
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxTextBoxButton = _resolveComponent("DxTextBoxButton")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxTreeView = _resolveComponent("DxTreeView")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!
  const _component_DxDropDownOptions = _resolveComponent("DxDropDownOptions")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxDateBox = _resolveComponent("DxDateBox")!
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!
  const _component_DxTabPanel = _resolveComponent("DxTabPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_DxDataGrid, {
        ref: $data.documenteDataGrid,
        allowColumnReordering: true,
        "data-source": $data.dsDocumente,
        allowColumnResizing: true,
        columnAutoWidth: false,
        "column-min-width": 10,
        columnResizingMode: 'nextColumn',
        "show-borders": true,
        syncLookupFilterValues: false,
        "filter-sync-enabled": true,
        "show-column-lines": false,
        "show-row-lines": true,
        "row-alternation-enabled": true,
        "hover-state-enabled": true,
        height: "100%",
        class: "documente-grid",
        onRowDblClick: $options.onRowDblClick,
        onExporting: $options.onExporting
      }, {
        circleTemplate: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_2, [
            (data.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "✔"))
              : (_openBlock(), _createElementBlock("div", _hoisted_4))
          ])
        ]),
        deschideCellTemplate: _withCtx(({ data }) => [
          _createVNode(_component_DxButton, {
            icon: "eyeopen",
            hint: "Deschide Document",
            type: "default",
            "styling-mode": "outlined",
            class: "deschide-btn",
            onClick: () => $options.openDocument(data.data)
          }, null, 8, ["onClick"])
        ]),
        tipareseCellTemplate: _withCtx(({ data }) => [
          _createVNode(_component_DxButton, {
            icon: "print",
            hint: "Tipărește document",
            type: "default",
            "styling-mode": "outlined",
            class: "deschide-btn",
            disabled: $setup.isPrinting,
            onClick: () => $options.onTipareseDocument(data.data)
          }, null, 8, ["disabled", "onClick"])
        ]),
        filterToggleTemplate: _withCtx(() => [
          _createVNode(_component_DxButton, {
            icon: "filter",
            text: "Filtre",
            "styling-mode": "contained",
            class: "filter-toggle-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-filters')))
          })
        ]),
        periodToggleTemplate: _withCtx(() => [
          _createVNode(_component_DxButton, {
            icon: "event",
            text: "Perioadă",
            "styling-mode": "contained",
            class: "filter-toggle-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-filters', 'date')))
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxExport, {
            enabled: true,
            formats: ["xlsx"],
            "load-panel": { enabled: true, showIndicator: true, text: 'Loading...' }
          }),
          _createVNode(_component_DxFilterRow, { visible: true }),
          _createVNode(_component_DxGrouping, { "context-menu-enabled": true }, {
            default: _withCtx(() => [
              _createVNode(_component_DxTexts, {
                "group-continued-message": "Continuat de pe pagina anterioara",
                "group-continues-message": "Continuat pe pagina urmatoare"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxGroupPanel, {
            visible: true,
            emptyPanelText: "Trage aici o coloana pentru a grupa datele"
          }),
          _createVNode(_component_DxLoadPanel, {
            enabled: true,
            text: "Loading...",
            "indicator-src": 'reload6.gif'
          }),
          _createVNode(_component_DxSorting, { mode: "multiple" }),
          _createVNode(_component_DxStateStoring, {
            enabled: true,
            type: "custom",
            "custom-save": $options.onGridStateSaving,
            "custom-load": $options.onGridStateLoading
          }, null, 8, ["custom-save", "custom-load"]),
          _createVNode(_component_DxColumnChooser, {
            enabled: true,
            mode: "select",
            title: "Selector coloane",
            allowSearch: true,
            sortOrder: "asc"
          }),
          _createVNode(_component_DxPaging, { "page-size": 10 }),
          _createVNode(_component_DxPager, {
            "show-page-size-selector": true,
            "allowed-page-sizes": [5, 10, 20],
            "show-info": true,
            "show-navigation-buttons": true
          }),
          _createVNode(_component_DxToolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_DxItem, {
                location: "before",
                template: "filterToggleTemplate"
              }),
              _createVNode(_component_DxItem, {
                location: "before",
                template: "periodToggleTemplate"
              }),
              _createVNode(_component_DxItem, {
                widget: "dxButton",
                location: "after",
                options: $data.addButtonOptions
              }, null, 8, ["options"]),
              _createVNode(_component_DxItem, { name: "exportButton" }),
              _createVNode(_component_DxItem, { name: "columnChooserButton" })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, {
            caption: "",
            width: "50",
            fixed: true,
            "fixed-position": "left",
            "allow-sorting": false,
            "allow-filtering": false,
            "allow-resizing": true,
            "allow-reordering": false,
            "cell-template": "deschideCellTemplate"
          }),
          _createVNode(_component_DxColumn, {
            caption: "",
            width: "50",
            fixed: true,
            "fixed-position": "left",
            "allow-sorting": false,
            "allow-filtering": false,
            "allow-resizing": true,
            "allow-reordering": false,
            "cell-template": "tipareseCellTemplate"
          }),
          _createVNode(_component_DxColumn, { "data-field": "Numar" }),
          _createVNode(_component_DxColumn, { "data-field": "Categorie" }),
          _createVNode(_component_DxColumn, { "data-field": "Tip" }),
          _createVNode(_component_DxColumn, {
            "data-field": "Data",
            caption: "Data Contabila",
            "data-type": "date",
            format: "yyyy-MM-dd"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Document",
            caption: "Document asociat",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Zona",
            caption: "Zona",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "AgentNume",
            caption: "Nume Agent",
            allowHiding: false,
            showInColumnChooser: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Curs",
            caption: "Custom Curs Valutar",
            visible: false,
            "data-type": "number",
            format: "#,##0.0000",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "LotFabricatie",
            caption: "Lot Fabricatie",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "TvaLaIncasare",
            caption: "TVA La Incasare?",
            visible: false,
            cellTemplate: "circleTemplate",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Explicatie",
            caption: "Explicatie",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DiverseExplicatii",
            caption: "Diverse Explicatii",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Observatii",
            caption: "Observatii",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ContractNumar",
            caption: "Numar Contract",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "LocDepozitare",
            caption: "Loc de Depozitare",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Autofacturat",
            caption: "Autofacturat?",
            visible: false,
            cellTemplate: "circleTemplate",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Nota",
            caption: "Nota Contabila",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "GrupPartener",
            caption: "Grup Partener",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Partener",
            caption: "Nume Partener",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PartenerStrada",
            caption: "Strada Partener",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PartenerStradaNumar",
            caption: "Numar Strada Partener",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PartenerScaraBloc",
            caption: "Scara Bloc Partener",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PartenerBloc",
            caption: "Bloc Partener",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PartenerLocalitate",
            caption: "Localitate Partener",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PartenerAtributFiscal",
            caption: "Atribut Fiscal Partener",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PartenerCod",
            caption: "Cod Partener",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PartenerCUI",
            caption: "CUI Partener",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DataDoc",
            caption: "Data Document",
            visible: false,
            "data-type": "date",
            format: "yyyy-MM-dd"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Scadenta",
            caption: "Data Scadenta",
            visible: false,
            "data-type": "date",
            format: "yyyy-MM-dd"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "AreCAF",
            caption: "Are CAF?",
            visible: false,
            "cell-template": "circleTemplate",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ProcentCAF",
            caption: "Procent CAF",
            visible: false,
            "data-type": "number",
            format: "#,##0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ValoareCAF",
            caption: "Valoare CAF",
            visible: false,
            "data-type": "number",
            format: "#,##0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "GestiuneIntrare",
            caption: "Gestiune Intrare",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "GestiuneIesire",
            caption: "Gestiune Iesire",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "GestionarIntrare",
            caption: "Gestionar Intrare",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "GestionarIesire",
            caption: "Gestionar Iesire",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DataCreare",
            caption: "Data Creare",
            visible: false,
            "data-type": "date",
            format: "yyyy-MM-dd"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DataModificare",
            caption: "Data Modificare",
            visible: false,
            "data-type": "date",
            format: "yyyy-MM-dd"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "UserCreare",
            caption: "User Creare",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "UserModificare",
            caption: "User Modificare",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ValoareRON",
            caption: "Valoare in RON",
            visible: false,
            "data-type": "number",
            alignment: "right",
            format: "#,##0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ValoareTVARON",
            caption: "Valoare TVA in RON",
            visible: false,
            "data-type": "number",
            format: "#,##0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "TotalRON",
            caption: "Total in RON",
            visible: false,
            "data-type": "number",
            format: "#,##0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "SoldRON",
            caption: "Sold RON",
            visible: false,
            "data-type": "number",
            format: "#,##0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Valoare",
            caption: "Valoare",
            visible: false,
            "data-type": "number",
            alignment: "right",
            format: "#,##0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Valuta",
            visible: false,
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "TVA",
            caption: "TVA",
            visible: false,
            "data-type": "number",
            alignment: "right",
            format: "#0'%'",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ValoareTVA",
            caption: "Valoare TVA",
            visible: false,
            "data-type": "number",
            format: "#,##0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Total",
            caption: "Total",
            visible: false,
            "data-type": "number",
            format: "#,##0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Adaos",
            caption: "Adaos",
            visible: false,
            "data-type": "number",
            format: "#,##0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "AdaosValoare",
            caption: "Valoare Adaos",
            visible: false,
            "data-type": "number",
            format: "#,##0.00",
            allowSearch: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Sold",
            caption: "Sold",
            visible: false,
            "data-type": "number",
            format: "#,##0.00",
            allowSearch: false
          })
        ]),
        _: 1
      }, 8, ["data-source", "onRowDblClick", "onExporting"])
    ]),
    _createVNode(_component_DxPopup, {
      visible: $data.sharePopupVisible,
      width: "430",
      height: "170",
      showTitle: true,
      hideOnOutsideClick: $options.switchSharePopup,
      "drag-enabled": true,
      position: "center"
    }, {
      title: _withCtx(() => [...(_cache[16] || (_cache[16] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Copiază Link Detalii Document ", -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_DxTextBox, {
            value: $data.url,
            readOnly: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxTextBoxButton, {
                options: $data.copyButton,
                name: "copy",
                readOnly: false
              }, null, 8, ["options"])
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "hideOnOutsideClick"]),
    _createVNode(_component_DxPopup, {
      visible: $setup.isPdfPreviewVisible,
      width: 1000,
      height: 800,
      "drag-enabled": true,
      "resize-enabled": true,
      "hide-on-outside-click": true,
      "onUpdate:visible": _cache[2] || (_cache[2] = v => { if (!v) $setup.closePdfPreview(); })
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, _toDisplayString($setup.pdfFileName || 'Previzualizare document'), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            ($setup.pdfBlobUrl)
              ? (_openBlock(), _createElementBlock("iframe", {
                  key: 0,
                  src: $setup.pdfPreviewSrc,
                  style: {"width":"100%","height":"100%","border":"0"}
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_DxButton, {
              text: "Descarcă PDF",
              icon: "download",
              type: "success",
              onClick: $setup.downloadPreviewReport
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              text: "Închide",
              type: "danger",
              icon: "close",
              onClick: $setup.closePdfPreview
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: $data.isTipPopupVisible,
      "show-title": true,
      height: "320px",
      width: "520px",
      "drag-enabled": true,
      "show-close-button": false
    }, {
      title: _withCtx(() => [...(_cache[17] || (_cache[17] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("i", { class: "dx-icon-add popup-header-icon" }),
          _createElementVNode("span", { class: "popup-header-title" }, "Document nou")
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_DxDropDownBox, {
            ref: "dropDownBoxRef",
            "data-source": $data.dsTipDocumente,
            value: $data.newDocument.TipId,
            "value-expr": "Id",
            "display-expr": "Nume",
            placeholder: "Selectează un tip de document...",
            showClearButton: true,
            onValueChanged: $options.onDropDownValueChanged
          }, {
            content: _withCtx(({ data }) => [
              ($data.treeViewDataSource)
                ? (_openBlock(), _createBlock(_component_DxTreeView, {
                    key: 0,
                    "data-source": $data.treeViewDataSource,
                    "select-by-click": true,
                    "data-structure": "tree",
                    "items-expr": "items",
                    "key-expr": "Id",
                    "search-enabled": true,
                    "search-mode": "contains",
                    "select-nodes-recursive": false,
                    "expand-nodes-on-search": true,
                    onItemClick: $options.onTreeViewItemSelectionChanged,
                    "focus-state-enabled": true,
                    "display-expr": "Nume"
                  }, {
                    item: _withCtx(({ data: itemData }) => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ fontWeight: itemData.isCategory ? 'bold' : 'normal' })
                      }, _toDisplayString(itemData.Nume), 5)
                    ]),
                    _: 1
                  }, 8, ["data-source", "onItemClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data-source", "value", "onValueChanged"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_DxButton, {
              text: "Continuă",
              type: "success",
              width: "120",
              height: "32",
              "styling-mode": "outlined",
              onClick: $options.onTipContinue
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              text: "Anulează",
              type: "danger",
              width: "120",
              height: "32",
              "styling-mode": "outlined",
              onClick: $options.onCloseTipPopup
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: $data.isModalAddVisible,
      "show-title": true,
      height: "520px",
      width: "640px",
      "drag-enabled": true,
      "show-close-button": false
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _cache[18] || (_cache[18] = _createElementVNode("i", { class: "dx-icon-add popup-header-icon" }, null, -1)),
          _createElementVNode("span", _hoisted_15, "Adăugare document" + _toDisplayString($data.tipNumeSelectat ? ' — ' + $data.tipNumeSelectat : ''), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxTabPanel, {
          items: $data.addTabItems,
          "selected-index": $data.addSelectedTabIndex,
          onOptionChanged: $options.onAddTabPanelOptionChanged,
          "swipe-enabled": false,
          class: "filters-tabpanel modern-form"
        }, {
          title: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("i", {
                class: _normalizeClass(data.icon)
              }, null, 2),
              _createElementVNode("span", _hoisted_17, _toDisplayString(data.title), 1)
            ])
          ]),
          item: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_18, [
              (data.id === 'general')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_DxTextBox, {
                        label: "Număr Document",
                        "label-mode": "static",
                        value: $data.newDocument.Numar,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($data.newDocument.Numar) = $event)),
                        "read-only": $data.tipFlags?.EsteObligatie !== true,
                        hint: $data.tipFlags?.EsteObligatie === true ? 'Introduceți numărul documentului (ex. numărul facturii primite de la furnizor)' : 'Numărul se generează automat la salvare',
                        placeholder: $data.tipFlags?.EsteObligatie === true ? 'Introduceți numărul...' : ''
                      }, null, 8, ["value", "read-only", "hint", "placeholder"])
                    ]),
                    ($data.tipFlags?.ArePartener === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createVNode(_component_DxLookup, {
                            label: "Partener",
                            "label-mode": "static",
                            "data-source": $data.dsPartener,
                            value: $data.newDocument.PartenerId,
                            "value-expr": "ID",
                            "display-expr": "Nume",
                            placeholder: "Selectează un partener...",
                            showClearButton: true,
                            searchEnabled: true,
                            onValueChanged: $options.onPartenerSelected
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value", "onValueChanged"])
                        ]))
                      : _createCommentVNode("", true),
                    ($data.tipFlags?.AreAgentId === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createVNode(_component_DxLookup, {
                            label: "Agent",
                            "label-mode": "static",
                            "data-source": $data.dsAgent,
                            value: $data.newDocument.AgentId,
                            "value-expr": "Id",
                            "display-expr": "Nume",
                            placeholder: "Selectează un agent...",
                            showClearButton: true,
                            searchEnabled: true,
                            onValueChanged: $options.onAgentSelected
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value", "onValueChanged"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_DxDateBox, {
                        label: "Data Contabilă",
                        "label-mode": "static",
                        value: $data.newDocument.Data,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (($data.newDocument.Data) = $event)),
                        type: "date",
                        "display-format": "dd-MM-yyyy",
                        "show-clear-button": true
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_DxDateBox, {
                        label: "Data Document",
                        "label-mode": "static",
                        value: $data.newDocument.DataDoc,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (($data.newDocument.DataDoc) = $event)),
                        type: "date",
                        "display-format": "dd-MM-yyyy",
                        "show-clear-button": true
                      }, null, 8, ["value"])
                    ]),
                    ($data.tipFlags?.AreScadenta === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createVNode(_component_DxDateBox, {
                            label: "Data Scadență",
                            "label-mode": "static",
                            value: $data.newDocument.DataScadenta,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (($data.newDocument.DataScadenta) = $event)),
                            type: "date",
                            "display-format": "dd-MM-yyyy",
                            "show-clear-button": true
                          }, null, 8, ["value"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (data.id === 'financial')
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    (!$options.hasFinanciarTab)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Acest tip de document nu are câmpuri financiare suplimentare."))
                      : _createCommentVNode("", true),
                    ($data.tipFlags?.AreIntrare === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createVNode(_component_DxLookup, {
                            label: "Gestiune Intrare",
                            "label-mode": "static",
                            "data-source": $data.dsGestiune,
                            value: $data.newDocument.GestiuneIntrareId,
                            "value-expr": "Id",
                            "display-expr": $options.gestiuneDisplayExpr,
                            placeholder: "Gestiune intrare...",
                            showClearButton: true,
                            searchEnabled: true,
                            onValueChanged: $options.onGestiuneIntrareSelected
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value", "display-expr", "onValueChanged"])
                        ]))
                      : _createCommentVNode("", true),
                    ($data.tipFlags?.AreIesire === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createVNode(_component_DxLookup, {
                            label: "Gestiune Ieșire",
                            "label-mode": "static",
                            "data-source": $data.dsGestiune,
                            value: $data.newDocument.GestiuneIesireId,
                            "value-expr": "Id",
                            "display-expr": $options.gestiuneDisplayExpr,
                            placeholder: "Gestiune ieșire...",
                            showClearButton: true,
                            searchEnabled: true,
                            onValueChanged: $options.onGestiuneIesireSelected
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value", "display-expr", "onValueChanged"])
                        ]))
                      : _createCommentVNode("", true),
                    ($data.tipFlags?.AreBanca === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createVNode(_component_DxLookup, {
                            label: "Cont Bancă/Casă",
                            "label-mode": "static",
                            "data-source": $data.dsBanci,
                            value: $data.newDocument.ContBancaCasaId,
                            "value-expr": "Id",
                            "display-expr": $options.bancaDisplayExpr,
                            placeholder: "Selectează un cont...",
                            showClearButton: true,
                            searchEnabled: true,
                            onValueChanged: $options.onBancaSelected
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value", "display-expr", "onValueChanged"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_31, [
                      ($data.tipFlags?.AreValuta === true)
                        ? (_openBlock(), _createBlock(_component_DxLookup, {
                            key: 0,
                            label: "Valută",
                            "label-mode": "static",
                            "data-source": $data.dsValute,
                            value: $data.newDocument.ValutaId,
                            "value-expr": "Id",
                            "display-expr": "Simbol",
                            placeholder: "Valută...",
                            showClearButton: true,
                            searchEnabled: true,
                            onValueChanged: $options.onValutaSelected
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value", "onValueChanged"]))
                        : _createCommentVNode("", true),
                      ($data.tipFlags?.AreValuta === true)
                        ? (_openBlock(), _createBlock(_component_DxNumberBox, {
                            key: 1,
                            label: "Curs",
                            "label-mode": "static",
                            value: $data.newDocument.Curs,
                            readOnly: true,
                            onValueChanged: $options.onCursSelected
                          }, null, 8, ["value", "onValueChanged"]))
                        : _createCommentVNode("", true),
                      ($data.tipFlags?.AreAdaos === true)
                        ? (_openBlock(), _createBlock(_component_DxNumberBox, {
                            key: 2,
                            label: "Adaos (%)",
                            "label-mode": "static",
                            value: $data.newDocument.Adaos,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (($data.newDocument.Adaos) = $event)),
                            format: "#0.00'%'",
                            min: 0,
                            max: 100
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true),
                      ($data.tipFlags?.AreAdaos === true)
                        ? (_openBlock(), _createBlock(_component_DxNumberBox, {
                            key: 3,
                            label: "Adaos (Val.)",
                            "label-mode": "static",
                            value: 0,
                            format: "#,##0.00",
                            "read-only": true,
                            hint: "Se calculează din liniile documentului"
                          }))
                        : _createCommentVNode("", true),
                      ($data.tipFlags?.AreValoare === true)
                        ? (_openBlock(), _createBlock(_component_DxNumberBox, {
                            key: 4,
                            label: "Valoare",
                            "label-mode": "static",
                            value: $data.newDocument.Valoare,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (($data.newDocument.Valoare) = $event)),
                            format: "#,##0.00",
                            "read-only": $data.tipFlags?.AreLinii === true
                          }, null, 8, ["value", "read-only"]))
                        : _createCommentVNode("", true),
                      ($data.tipFlags?.AreTva === true)
                        ? (_openBlock(), _createBlock(_component_DxNumberBox, {
                            key: 5,
                            label: "TVA %",
                            "label-mode": "static",
                            value: $data.newDocument.Tva,
                            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (($data.newDocument.Tva) = $event)),
                            format: "#0",
                            min: 0,
                            max: 100
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true),
                      ($data.tipFlags?.AreValoare === true && $data.tipFlags?.AreTva === true)
                        ? (_openBlock(), _createBlock(_component_DxNumberBox, {
                            key: 6,
                            label: "Valoare TVA",
                            "label-mode": "static",
                            value: $data.newDocument.ValoareTva,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (($data.newDocument.ValoareTva) = $event)),
                            format: "#,##0.00",
                            "read-only": $data.tipFlags?.AreLinii === true
                          }, null, 8, ["value", "read-only"]))
                        : _createCommentVNode("", true),
                      ($data.tipFlags?.AreValoare === true && $data.tipFlags?.AreTva === true)
                        ? (_openBlock(), _createBlock(_component_DxNumberBox, {
                            key: 7,
                            label: "Total",
                            "label-mode": "static",
                            value: $data.newDocument.Total,
                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (($data.newDocument.Total) = $event)),
                            format: "#,##0.00",
                            "read-only": $data.tipFlags?.AreLinii === true
                          }, null, 8, ["value", "read-only"]))
                        : _createCommentVNode("", true),
                      ($data.tipFlags?.AreValoare === true && $data.tipFlags?.CrossCateg !== 0)
                        ? (_openBlock(), _createBlock(_component_DxNumberBox, {
                            key: 8,
                            label: "Sold",
                            "label-mode": "static",
                            value: $data.newDocument.Total,
                            format: "#,##0.00",
                            "read-only": true,
                            hint: "Egal cu Total la creare"
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (data.id === 'referinte')
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    (!$options.hasReferinteTab)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Acest tip de document nu are referințe suplimentare."))
                      : _createCommentVNode("", true),
                    ($data.tipFlags?.AreProiect === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createVNode(_component_DxLookup, {
                            label: "Proiect",
                            "label-mode": "static",
                            "data-source": $data.dsProiecte,
                            value: $data.newDocument.ProiectId,
                            "value-expr": "Id",
                            "display-expr": "Nume",
                            placeholder: "Selectează un proiect...",
                            showClearButton: true,
                            searchEnabled: true,
                            onValueChanged: $options.onProiectSelected
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value", "onValueChanged"])
                        ]))
                      : _createCommentVNode("", true),
                    ($data.tipFlags?.AreContract === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createVNode(_component_DxLookup, {
                            label: "Contract",
                            "label-mode": "static",
                            "data-source": $data.dsContracte,
                            value: $data.newDocument.ContractId,
                            "value-expr": "Id",
                            "display-expr": "NumeContract",
                            placeholder: "Selectează un contract...",
                            showClearButton: true,
                            searchEnabled: true,
                            onValueChanged: $options.onContractSelected
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value", "onValueChanged"])
                        ]))
                      : _createCommentVNode("", true),
                    ($data.tipFlags?.AreComanda === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createVNode(_component_DxLookup, {
                            label: "Comandă",
                            "label-mode": "static",
                            "data-source": $data.dsComenzi,
                            value: $data.newDocument.ComandaId,
                            "value-expr": "Id",
                            "display-expr": "Cod",
                            placeholder: "Selectează o comandă...",
                            showClearButton: true,
                            searchEnabled: true,
                            onValueChanged: $options.onComandaSelected
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value", "onValueChanged"])
                        ]))
                      : _createCommentVNode("", true),
                    ($data.tipFlags?.AreLotFabricatie === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createVNode(_component_DxLookup, {
                            label: "Lot Fabricație",
                            "label-mode": "static",
                            "data-source": $data.dsLoturiFabricatie,
                            value: $data.newDocument.LotFabricatieId,
                            "value-expr": "Id",
                            "display-expr": "Cod",
                            placeholder: "Selectează un lot...",
                            showClearButton: true,
                            searchEnabled: true,
                            onValueChanged: $options.onLotFabricatieSelected
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value", "onValueChanged"])
                        ]))
                      : _createCommentVNode("", true),
                    ($data.tipFlags?.AreStructIdEditabil === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createVNode(_component_DxLookup, {
                            label: "Structură Editabilă",
                            "label-mode": "static",
                            "data-source": $data.dsStructuriIdEditabile,
                            value: $data.newDocument.StructIdEditabil,
                            "value-expr": "Id",
                            "display-expr": "Nume",
                            placeholder: "Selectează o structură...",
                            showClearButton: true,
                            searchEnabled: true,
                            onValueChanged: $options.onStructuraIdEditabilaSelected
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value", "onValueChanged"])
                        ]))
                      : _createCommentVNode("", true),
                    ($data.tipFlags?.AreDocument === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createVNode(_component_DxLookup, {
                            label: "Document Asociat",
                            "label-mode": "static",
                            "data-source": $data.dsDocumenteAsociate,
                            value: $data.newDocument.DocGeneratAutomatId,
                            "value-expr": "Id",
                            "display-expr": "Numar",
                            placeholder: "Selectează documentul asociat...",
                            showClearButton: true,
                            searchEnabled: true,
                            onValueChanged: $options.onDocumentAsociatSelected
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value", "onValueChanged"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (data.id === 'aprobare')
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_DxLookup, {
                        label: "Aprobă",
                        "label-mode": "static",
                        "data-source": $data.dsPerEmployees,
                        value: $data.newDocument.AprobaId,
                        "value-expr": "Id",
                        "display-expr": $options.perEmployeeDisplayExpr,
                        placeholder: "Selectează persoana care aprobă...",
                        showClearButton: true,
                        searchEnabled: true,
                        onValueChanged: $options.onAprobaSelected
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxDropDownOptions, { "show-title": false })
                        ]),
                        _: 1
                      }, 8, ["data-source", "value", "display-expr", "onValueChanged"])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_DxCheckBox, {
                        text: "Anulat",
                        value: $data.newDocument.Anulat,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (($data.newDocument.Anulat) = $event))
                      }, null, 8, ["value"]),
                      ($data.tipFlags?.AreIntrare === true || $data.tipFlags?.AreIesire === true || $data.tipFlags?.EsteCreanta === true || $data.tipFlags?.EsteObligatie === true)
                        ? (_openBlock(), _createBlock(_component_DxCheckBox, {
                            key: 0,
                            text: "Stornat/Retur",
                            value: $data.newDocument.StornatRetur,
                            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (($data.newDocument.StornatRetur) = $event))
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true),
                      ($data.tipFlags?.EsteCreanta === true || $data.tipFlags?.EsteObligatie === true)
                        ? (_openBlock(), _createBlock(_component_DxCheckBox, {
                            key: 1,
                            text: "Autofacturat",
                            value: $data.newDocument.Autofacturat,
                            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (($data.newDocument.Autofacturat) = $event))
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true),
                      ($data.tipFlags?.EsteCreanta === true || $data.tipFlags?.EsteObligatie === true)
                        ? (_openBlock(), _createBlock(_component_DxCheckBox, {
                            key: 2,
                            text: "Emis Terț",
                            value: $data.newDocument.EmisTert,
                            "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (($data.newDocument.EmisTert) = $event))
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (data.id === 'note')
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    (!$options.hasNoteTab)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, "Acest tip de document nu are note suplimentare."))
                      : _createCommentVNode("", true),
                    ($data.tipFlags?.AreExplicatie === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createVNode(_component_DxTextArea, {
                            label: "Explicație",
                            "label-mode": "static",
                            value: $data.newDocument.Explicatie,
                            height: "52px",
                            onValueChanged: $options.onExplicatieSelected
                          }, null, 8, ["value", "onValueChanged"])
                        ]))
                      : _createCommentVNode("", true),
                    ($data.tipFlags?.AreObservatii === true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createVNode(_component_DxTextArea, {
                            label: "Observații",
                            "label-mode": "static",
                            value: $data.newDocument.Observatii,
                            height: "52px",
                            onValueChanged: $options.onObservatiiSelected
                          }, null, 8, ["value", "onValueChanged"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["items", "selected-index", "onOptionChanged"]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_component_DxButton, {
              text: "Salvează",
              type: "success",
              width: "120",
              height: "32",
              "styling-mode": "outlined",
              onClick: $options.onSaveAdd
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              text: "Închide",
              type: "danger",
              width: "120",
              height: "32",
              "styling-mode": "outlined",
              onClick: $options.onCloseAdd
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}